export default "__VITE_ASSET__cbf03a8b__"